const crypto = require('crypto');
import urlUtils from '../utils/urlUtils.js';
const { decodeJwt } = require("jose");

const defaults = {
    accessTokenKey: 'access_token_lp2',
    idTokenKey: 'id_token_lp2',
    codeVerifierKey: 'codeVerifier_lp2',
    codeChallengeKey: 'codeChallenge_lp2',
    openidConfigKey: 'openid-config_lp2'
};

export const generateAuthUrlFromConfig = (idamClientConfig) => {
    return fetchIdamOpenIdConfig(idamClientConfig).then((config) => {
        let authzUrl = config.authorization_endpoint;
        const userType = urlUtils.getParameterByName('user_type');
        const clientId = idamClientConfig.client_id[userType.toLowerCase()];
        const localeId = urlUtils.getParameterByName('locale_id') || 'en-GB';
        const countryCode = urlUtils.getParameterByName('country_code') || 'default';

        let scopes = idamClientConfig.scopes;
        scopes.push('clnt=' + clientId);

        let redirectUri = formRedirectUri(idamClientConfig, window.location.href);
        
        authzUrl = urlUtils.setQueryParameter('realm_id', idamClientConfig.realm_id, authzUrl);
        authzUrl = urlUtils.setQueryParameter('client_id', clientId, authzUrl);
        authzUrl = urlUtils.setQueryParameter('user_type', userType, authzUrl);
        authzUrl = urlUtils.setQueryParameter('country_code', countryCode, authzUrl);
        authzUrl = urlUtils.setQueryParameter('locale_id', localeId, authzUrl);
        authzUrl = urlUtils.setQueryParameter('response_type', idamClientConfig.response_type, authzUrl);
        authzUrl = urlUtils.setQueryParameter('scope', scopes.join(' '), authzUrl);
        authzUrl = urlUtils.setQueryParameter('redirect_uri', encodeURIComponent(redirectUri), authzUrl);
        authzUrl = urlUtils.setQueryParameter('code_challenge', generateAndStoreCodeChallenge(idamClientConfig.code_challenge_method), authzUrl);
        authzUrl = urlUtils.setQueryParameter('code_challenge_method', idamClientConfig.code_challenge_method, authzUrl);
        authzUrl = urlUtils.setQueryParameter('nonce', 'noncelp', authzUrl);

        return Promise.resolve(authzUrl);
    });
}

export const generateAuthUrlFromConfigForSilentAuth = (idamClientConfig) => {
    return fetchIdamOpenIdConfig(idamClientConfig).then((config) => {
        let authzUrl = config.authorization_endpoint;
        const userType = urlUtils.getParameterByName('user_type');
        const clientId = idamClientConfig.client_id[userType.toLowerCase()];
        const localeId = urlUtils.getParameterByName('locale_id') || 'en-GB';
        const countryCode = urlUtils.getParameterByName('country_code') || 'default';


        let scopes = idamClientConfig.scopes;
        scopes.push('clnt=' + clientId);

        let redirectUri = formRedirectUri(idamClientConfig, window.location.href);
        
        authzUrl = urlUtils.setQueryParameter('prompt', 'none', authzUrl);
        authzUrl = urlUtils.setQueryParameter('realm_id', idamClientConfig.realm_id, authzUrl);
        authzUrl = urlUtils.setQueryParameter('client_id', clientId, authzUrl);
        authzUrl = urlUtils.setQueryParameter('user_type', userType, authzUrl);
        authzUrl = urlUtils.setQueryParameter('country_code', countryCode, authzUrl);
        authzUrl = urlUtils.setQueryParameter('locale_id', localeId, authzUrl);
        authzUrl = urlUtils.setQueryParameter('response_type', idamClientConfig.response_type, authzUrl);
        authzUrl = urlUtils.setQueryParameter('scope', scopes.join(' '), authzUrl);
        authzUrl = urlUtils.setQueryParameter('redirect_uri', encodeURIComponent(redirectUri), authzUrl);
        authzUrl = urlUtils.setQueryParameter('code_challenge', generateAndStoreCodeChallenge(idamClientConfig.code_challenge_method), authzUrl);
        authzUrl = urlUtils.setQueryParameter('code_challenge_method', idamClientConfig.code_challenge_method, authzUrl);
        authzUrl = urlUtils.setQueryParameter('nonce', 'noncelp', authzUrl);

        return Promise.resolve(authzUrl);
    });
}

export const fetchAccessTokenFromCode = (idamClientConfig, code, url) => {
    return fetchIdamOpenIdConfig(idamClientConfig).then((config) => {
        const userType = urlUtils.getParameterByName('user_type', redirectUri);
        let redirectUri = formRedirectUri(idamClientConfig, url);

        let data = "client_id=" + idamClientConfig.client_id[userType.toLowerCase()] +
            "&grant_type=" + idamClientConfig.grant_type +
            "&code=" + code +
            "&redirect_uri=" + encodeURIComponent(redirectUri)
            + "&code_verifier=" + fetchCodeVerifierFromLocal();

        return fetch(config.token_endpoint, {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: data
        })
            .then(res => res.json())
            .then(
                (result) => {
                    clearCodeChallengeAndVerfier();
                    return result;
                });
    });
}

export const formRedirectUri = (idamClientConfig, url) => {

    let windowUrl= url.split("#")[0];
    let userType = urlUtils.getParameterByName('user_type', windowUrl);
    let countryCode = urlUtils.getParameterByName('country_code', windowUrl) || 'default';
    let localeId = urlUtils.getParameterByName('locale_id', windowUrl) || 'en-GB';
    
    let redirectUri = idamClientConfig.redirect_uri;
    redirectUri = urlUtils.setQueryParameter('user_type', userType, redirectUri);
    redirectUri = urlUtils.setQueryParameter('country_code', countryCode, redirectUri);
    redirectUri = urlUtils.setQueryParameter('locale_id', localeId, redirectUri);
    
    return redirectUri.split("#")[0];

}

export const generateLogoutUrl = (idamClientConfig, idToken) => {
    const id_token = idToken || fetchIdTokenFromLocal();
    const postLogoutRedirectUri = formLoginPreferencesLink(idamClientConfig, window.location.href);
    return fetchIdamOpenIdConfig(idamClientConfig).then((config) => {
        //const end_session_url = new URL(config.end_session_endpoint)
        let end_session_url = config.end_session_endpoint;
        end_session_url = urlUtils.setQueryParameter('id_token_hint', id_token, end_session_url);
        end_session_url = urlUtils.setQueryParameter('post_logout_redirect_uri', encodeURIComponent(postLogoutRedirectUri), end_session_url);
        return Promise.resolve(end_session_url);
    });
}

export const formLoginPreferencesLink = (idamClientConfig, url) => {
    let windowUrl= url.split("#")[0];
    
    let userType = urlUtils.getParameterByName('user_type', windowUrl);
    let localeId = urlUtils.getParameterByName('locale_id', windowUrl) || 'en-GB';
    let countryCode = urlUtils.getParameterByName('country_code', windowUrl) || 'default';
    
    let loginPreferencesLink = idamClientConfig.postLogoutRedirectUri;
    loginPreferencesLink = urlUtils.setQueryParameter('user_type', userType, loginPreferencesLink);
    loginPreferencesLink = urlUtils.setQueryParameter('country_code', countryCode, loginPreferencesLink);
    loginPreferencesLink = urlUtils.setQueryParameter('locale_id', localeId, loginPreferencesLink);
    
    return loginPreferencesLink.split("#")[0];
}

function base64URLEncode(str) {
    return str.toString('base64')
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');
}

export const generateRandomCodeVerfier = () => {
    return base64URLEncode(crypto.randomBytes(32));

}

function sha256(buffer, hashMethod) {
    return crypto.createHash(hashMethod).update(buffer).digest();
    // return crypto.createHash('sha256').update(buffer).digest();
}
export const generateCodeChallenge = (codeVerifier, hashMethod) => {
    if (hashMethod == 'S256')
        return base64URLEncode(sha256(codeVerifier, 'sha256'));
    else
        return codeVerifier
}

function generateAndStoreCodeChallenge(hashMethod) {
    var codeVerifier = generateRandomCodeVerfier();
    var codeChallenge = generateCodeChallenge(codeVerifier, hashMethod);
    window.localStorage.setItem(defaults.codeVerifierKey, codeVerifier);
    window.localStorage.setItem(defaults.codeChallengeKey, codeChallenge);
    return codeChallenge;
}

export const fetchCodeVerifierFromLocal = () => {
    return window.localStorage.getItem(defaults.codeVerifierKey);
}
export const fetchCodeChallengeFromLocal = () => {
    return window.localStorage.getItem(defaults.codeChallengeKey);
}


export const clearCodeChallengeAndVerfier = () => {
    window.localStorage.removeItem(defaults.codeVerifierKey);
    window.localStorage.removeItem(defaults.codeChallengeKey);
}


export const storeIdamOpenIdConfigCache = (openIdConfig) => {
    window.localStorage.setItem(defaults.openidConfigKey, openIdConfig);
}

export const fetchIdamOpenIdConfig = (idamClientConfig) => {
    const openIdUrl = idamClientConfig.openIdConfiguration;
    const openIdConfigFromLocal = window.localStorage.getItem(defaults.openidConfigKey);
    return openIdConfigFromLocal == null ? fetch(openIdUrl, {
        method: 'GET',
        mode: 'cors'
    })
        .then(res => res.json())
        .then(
            (result) => {
                storeIdamOpenIdConfigCache(JSON.stringify(result));
                return Promise.resolve(result);
            }) : Promise.resolve(JSON.parse(openIdConfigFromLocal));
}

export const storeAccessToken = (access_token, id_token) => {
    window.localStorage.setItem(defaults.accessTokenKey, access_token);
    window.localStorage.setItem(defaults.idTokenKey, id_token);
}

export const fetchAccessTokenFromLocal = () => {
    return window.localStorage.getItem(defaults.accessTokenKey);
}

export const fetchIdTokenFromLocal = () => {
    return window.localStorage.getItem(defaults.idTokenKey);
}

export const readIdToken = () => {
    try {
        var token = window.localStorage.getItem(defaults.idTokenKey);
        return decodeJwt(token);
    }
    catch (e) {
        return null;
    }
}

export const clearLocalStorage = () => {
    window.localStorage.removeItem(defaults.accessTokenKey);
    window.localStorage.removeItem(defaults.idTokenKey);
    window.localStorage.removeItem(defaults.codeVerifierKey);
    window.localStorage.removeItem(defaults.codeChallengeKey);
    window.localStorage.removeItem(defaults.openidConfigKey);
}
